// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__EYPW+","content":"layout_content__9MZH5"};